import React from 'react';
import { Link } from 'react-router-dom';
import { formatMatterDate, matterAttention, matterFieldLabels, nextActionDate } from '../../utils/matterUtils';

export default function MatterTable({ matters, canManage, canEdit, onEdit, onArchive }) {
  if (!matters.length) {
    return <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">No matters found.</div>;
  }

  return (
    <div className="bg-white rounded-lg shadow overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100 text-left">
          <tr>
            <th className="px-4 py-3">Matter ID</th>
            <th className="px-4 py-3">Client / Matter</th>
            <th className="px-4 py-3">Law / Stage</th>
            <th className="px-4 py-3">Year / Period</th>
            <th className="px-4 py-3">Present Status</th>
            <th className="px-4 py-3">Next Action</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {matters.map((matter) => {
            const attention = matterAttention(matter);
            const labels = matterFieldLabels(matter.lawType);
            return (
              <tr key={matter.id} className={attention.key === 'overdue' ? 'bg-red-50' : ''}>
                <td className="px-4 py-3 font-mono text-xs">
                  <Link className="text-purple-700 hover:underline" to={`/matters/${matter.id}`}>{matter.matterCode || matter.id}</Link>
                </td>
                <td className="px-4 py-3">
                  <div className="font-medium">{matter.clientName || '—'}</div>
                  <div className="text-gray-600">{matter.title || matter.assignmentType || '—'}</div>
                  <div className="text-xs text-gray-500">{matter.assignedToName || 'Unassigned'}</div>
                </td>
                <td className="px-4 py-3">
                  <div>{matter.lawType || '—'}</div>
                  <div className="text-xs text-blue-700">{matter.currentStage || '—'}</div>
                </td>
                <td className="px-4 py-3">
                  <div>{matter.financialYear || '—'}</div>
                  <div className="text-xs text-gray-500">{labels.year}{matter.period ? ` · ${matter.period}` : ''}</div>
                </td>
                <td className="px-4 py-3 max-w-xs"><div className="truncate">{matter.currentStatus || matter.remarks || '—'}</div></td>
                <td className="px-4 py-3">
                  <div>{matter.nextAction || '—'}</div>
                  <div className="text-xs text-gray-500">{formatMatterDate(matter.nextActionDate || nextActionDate(matter))}</div>
                  {attention.label && <span className={`inline-block mt-1 rounded-full px-2 py-1 text-xs font-semibold ${attention.className}`}>{attention.label}</span>}
                </td>
                <td className="px-4 py-3"><span className="rounded-full px-2 py-1 text-xs font-semibold bg-purple-100 text-purple-800">{matter.status || 'Open'}</span></td>
                <td className="px-4 py-3 whitespace-nowrap space-x-2">
                  <Link to={`/matters/${matter.id}`} className="px-2 py-1 bg-purple-700 text-white rounded">Open Diary</Link>
                  {canEdit(matter) && <button onClick={() => onEdit(matter)} className="px-2 py-1 bg-yellow-400 rounded">Edit</button>}
                  {canManage && !matter.isArchived && <button onClick={() => onArchive(matter)} className="px-2 py-1 bg-red-600 text-white rounded">Archive</button>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
